import React, { useEffect, useMemo, useRef } from "react";
import { Group, Rect, Text } from "react-konva";

const MESSAGES = [
  { text: "Recibe bonos especiales", color: "#ffd54a" },
  { text: "Multiplica tus premios X2, X3 y X5", color: "#69e6ff" },
  { text: "Disfruta de 3 jackpots", color: "#ff9a5c" },
  { text: "Apuesta desde 10 pesos y gana en grande", color: "#7dff9b" },
  { text: "Controla tus jugadas desde tu celular", color: "#ffffff" },
  { text: "Juega, gana y vive la emoción de Corriendog", color: "#ff8fc6" },
];

const TICKER_FONT_FAMILY = "Arial";

const SportsTicker = ({ width, height, sizeRef }) => {
  const tickerRef = useRef(null);
  const barHeight = Math.max(height * 0.052, 42);
  const brandWidth = width * 0.15;
  const contentX = brandWidth + width * 0.008;
  const contentWidth = width - contentX;
  const fontSize = Math.max(Math.min(sizeRef / 44, 25), 13);
  const separator = "     ◆     ";

  const segments = useMemo(() => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    if (context) context.font = `700 ${fontSize}px ${TICKER_FONT_FAMILY}`;
    let offset = 0;
    return MESSAGES.map((message) => {
      const value = `${message.text}${separator}`;
      const measured = context?.measureText(value).width || value.length * fontSize * 0.62;
      const segment = { ...message, value, x: offset, width: Math.ceil(measured + fontSize * 0.5) };
      offset += segment.width;
      return segment;
    });
  }, [fontSize]);

  const tickerWidth = segments.reduce((total, segment) => total + segment.width, 0);

  useEffect(() => {
    let frame;
    let previousTime;
    const speed = Math.max(72, Math.min(108, width * 0.052));
    if (tickerRef.current) tickerRef.current.x(0);

    const animate = (currentTime) => {
      const ticker = tickerRef.current;
      if (ticker && tickerWidth > 0) {
        if (previousTime === undefined) previousTime = currentTime;
        const elapsed = Math.min(Math.max((currentTime - previousTime) / 1000, 0), 0.05);
        let nextX = ticker.x() - speed * elapsed;
        while (nextX <= -tickerWidth) nextX += tickerWidth;
        ticker.x(nextX);
        ticker.getLayer()?.batchDraw();
        previousTime = currentTime;
      }
      frame = window.requestAnimationFrame(animate);
    };

    frame = window.requestAnimationFrame(animate);
    return () => window.cancelAnimationFrame(frame);
  }, [tickerWidth, width]);

  return (
    <Group x={0} y={height - barHeight} width={width} height={barHeight} listening={false}>
      <Rect width={width} height={barHeight} fillLinearGradientStartPoint={{ x: 0, y: 0 }} fillLinearGradientEndPoint={{ x: width, y: 0 }} fillLinearGradientColorStops={[0, "#050b13", 0.5, "#0c1a29", 1, "#050b13"]} />
      <Rect width={width} height={2} fill="#f2c94c" shadowColor="#f2c94c" shadowBlur={4} />
      <Rect y={barHeight - 1} width={width} height={1} fill="#33485c" />

      <Rect width={brandWidth} height={barHeight} fillLinearGradientStartPoint={{ x: 0, y: 0 }} fillLinearGradientEndPoint={{ x: brandWidth, y: 0 }} fillLinearGradientColorStops={[0, "#8f0e20", 1, "#d31c37"]} />
      <Text text="CORRIENDOG" x={width * 0.008} width={brandWidth - width * 0.016} height={barHeight} fill="#fff" fontFamily="Arial" fontStyle="bold" fontSize={fontSize * 1.08} align="center" verticalAlign="middle" shadowColor="#000" shadowBlur={3} />

      <Group x={contentX} width={contentWidth} height={barHeight} clipX={0} clipY={0} clipWidth={contentWidth} clipHeight={barHeight}>
        <Group ref={tickerRef} height={barHeight}>
          {[0, 1].flatMap((copy) => segments.map((segment, index) => (
            <Text key={`${copy}-${index}`} x={copy * tickerWidth + segment.x} text={segment.value} height={barHeight} fill={segment.color} fontFamily={TICKER_FONT_FAMILY} fontStyle="bold" fontSize={fontSize} verticalAlign="middle" wrap="none" shadowColor="#000" shadowBlur={2} shadowOffsetY={1} />
          )))}
        </Group>
      </Group>

    </Group>
  );
};

export default SportsTicker;
